import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Components, Utils, translate } from 'versafleet-core';
import ReduxActions from 'reduxActions';

class JobCustomAddress extends React.Component {
  UNSAFE_componentWillMount() {
    this.props.dispatch(ReduxActions.constant.fetchCountryList());
    this.props.dispatch(ReduxActions.account.fetch());
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    // Fill in default country
    if (nextProps.countryList !== this.props.countryList) {
      let countryName = null;
      const { countryList } = nextProps;
      for (let i = 0; i < countryList.length; i += 1) {
        if (countryList[i].code === nextProps.account.default_country_code) {
          countryName = countryList[i].name;
          break;
        }
      }
      if (!Utils.Helper.isNonEmptyString(this.props.value.country)
        && Utils.Helper.isNonEmptyString(countryName)) {
        this._onChange('country', countryName, false);
      }
    }
  }

  _getDefaultForm = (address = {}) => ({
    name: address.name || null,
    line_1: address.line_1 || null,
    line_2: address.line_2 || null,
    city: address.city || null,
    zip: address.zip || null,
    country: address.country || null,
    contact_person: address.contact_person || null,
    contact_number: address.contact_number || null,
  });

  _onChange = (fieldName, value, shouldChange = true) => {
    const address = {
      ...this.props.value,
      [fieldName]: value,
    };

    this.props.onChange(address, shouldChange);
  }

  _getGeocodedAddress = async () => {
    const address = this.props.value;

    // Auto fill address if empty
    if (!Utils.Helper.isNonEmptyString(address.line_1)
      && Utils.Helper.isNonEmptyString(address.country)
      && Utils.Helper.isNonEmptyString(address.zip) && address.zip.length >= 3) {
      const geocodedAddress = await Utils.Geocoder.getAddress({
        line_1: address.zip,
        country: address.country,
      });

      if (!Utils.Helper.isNonEmptyString(address.line_1)
          && !Utils.Helper.isNullOrUndefined(geocodedAddress)) {
        this.props.onChange({
          ...address,
          name: geocodedAddress.name,
          line_1: geocodedAddress.line_1,
          line_2: geocodedAddress.line_2,
          city: geocodedAddress.city,
          state: geocodedAddress.state,
        });
      }
    }
  }

  _getCountryOptions() {
    return this.props.countryList.map(country => ({
      value: country.name,
      text: country.name,
      code: country.code,
    }));
  }

  _getAddressIndex() {
    return this.props.addressList.findIndex(address => (
      address.line_1 === this.props.value.line_1
        && (!Utils.Helper.isNullOrUndefined(address.line_2)
          && address.line_2 === this.props.value.line_2)
        && address.country === this.props.value.country
        && (!Utils.Helper.isNullOrUndefined(address.zip) && address.zip === this.props.value.zip)
        && (!Utils.Helper.isNullOrUndefined(address.city) && address.city === this.props.value.city)
    ));
  }

  _getAddressOptions() {
    return this.props.addressList.map((address, i) => ({
      value: i,
      text: address.name || address.line_1,
    }));
  }

  _selectAddress = (value) => {
    if (Utils.Helper.isNumber(value)) {
      const {
        // eslint-disable-next-line camelcase
        name, line_1, line_2, city, zip, country, contact_person, contact_number, email,
      } = this.props.addressList[value];
      this.props.onChange({
        name,
        line_1,
        line_2,
        city,
        zip,
        country,
        contact_person,
        contact_number,
        email,
      });
    }
  }

  _getNameError() {
    return [].concat(...['line_1', 'country', 'zip'].map(key => this.props.error[key] || []));
  }

  _renderPostalCodeNote() {
    const { strings, value: addressValue } = this.props;
    const address = addressValue || {};

    if (address.country !== 'Singapore' || address.line_1) {
      return null;
    }

    return (
      <div>
        <Components.InfoBox>
          {strings.postalCodeNote}
        </Components.InfoBox>
      </div>
    );
  }

  _renderMainAddress() {
    const {
      error, id, strings, value,
    } = this.props;

    return (
      <div>
        <Components.Form.Block fontWeight="REGULAR" iconClassName="" isRequired level={0}>
          <Components.Input.Textbox
            error={error.line_1}
            id={Utils.Helper.isNullOrUndefined(id) ? undefined : `${id}__line1-input`}
            onChange={val => this._onChange('line_1', val)}
            placeholder={strings.line1Hint}
            value={value.line_1}
          />
        </Components.Form.Block>

        <Components.Form.Block fontWeight="REGULAR" iconClassName="" level={0}>
          <Components.Input.Textbox
            error={error.line_2}
            id={Utils.Helper.isNullOrUndefined(id) ? undefined : `${id}__line2-input`}
            onChange={val => this._onChange('line_2', val)}
            placeholder={strings.line2Hint}
            value={value.line_2}
          />
        </Components.Form.Block>

        <Components.Form.Block fontWeight="REGULAR" iconClassName="" level={0}>
          <Components.Input.Textbox
            error={error.city}
            id={Utils.Helper.isNullOrUndefined(id) ? undefined : `${id}__city-input`}
            onChange={val => this._onChange('city', val)}
            placeholder={strings.cityHint}
            value={value.city}
          />
        </Components.Form.Block>

        <Components.Form.Block fontWeight="REGULAR" iconClassName="" level={0}>
          <Components.Input.Textbox
            error={error.zip}
            id={Utils.Helper.isNullOrUndefined(id) ? undefined : `${id}__postal-code-input`}
            onChange={val => this._onChange('zip', val)}
            onEnterKeyPressed={this._getGeocodedAddress}
            placeholder={strings.postalCodeHint}
            value={value.zip}
          />
          {this._renderPostalCodeNote()}
        </Components.Form.Block>

        <Components.Form.Block iconClassName="" level={0}>
          <Components.Input.Select
            error={error.country}
            id={Utils.Helper.isNullOrUndefined(id) ? undefined : `${id}__select-country-input`}
            onChange={val => this._onChange('country', val)}
            options={this._getCountryOptions()}
            placeholder={strings.countryHint}
            value={value.country}
          />
        </Components.Form.Block>
      </div>
    );
  }

  render() {
    return (
      <div className="vf-job__custom-address">
        <Components.Form.InputGroup>

          {/* Name of Building dropdown */}
          <Components.Form.Block
            fontWeight="REGULAR"
            iconClassName={this.props.iconClassName}
            iconText={this.props.iconText}
            isInputIcon
            level={0}
          >
            <Components.Input.Select
              error={this._getNameError()}
              id={Utils.Helper.isNullOrUndefined(this.props.id) ? undefined
                : `${this.props.id}__select-address-input`}
              onChange={this._selectAddress}
              options={this._getAddressOptions()}
              placeholder={this.props.strings.searchLocationHint}
              value={this.props.value.name}
            />
          </Components.Form.Block>

          {this._renderMainAddress()}
        </Components.Form.InputGroup>
      </div>
    );
  }
}

JobCustomAddress.displayName = 'Job Custom Address';

JobCustomAddress.propTypes = {
  account: PropTypes.shape({
    default_country_code: PropTypes.string,
  }).isRequired,
  addressList: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    line_1: PropTypes.string,
    line_2: PropTypes.string,
    country: PropTypes.string,
    zip: PropTypes.string,
    city: PropTypes.string,
    contact_person: PropTypes.string,
    contact_number: PropTypes.string,
    email: PropTypes.string,
  })).isRequired,
  countryList: PropTypes.arrayOf(PropTypes.shape({
    code: PropTypes.string,
    name: PropTypes.string,
  })).isRequired,
  dispatch: PropTypes.func.isRequired,
  error: PropTypes.shape(),
  iconClassName: PropTypes.string,
  iconText: PropTypes.string,
  id: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  strings: PropTypes.shape().isRequired,
  value: PropTypes.shape(),
};

JobCustomAddress.defaultProps = {
  error: {},
  iconClassName: null,
  iconText: null,
  id: null,
  value: null,
};

function mapStateToProps(state) {
  const { account, constant } = state;
  return {
    account: account.account,
    countryList: constant.countryList || [],
  };
}

export default connect(mapStateToProps)(translate('CustomAddress')(JobCustomAddress));
